import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AztecScannerResult} from '../../../../enums/next/aztec-scanner-result.enum';
import {NextAztecScannerService} from '../../../../services/next-aztec-scanner.service';
import {AztecScannerAction} from '../../../../enums/next/aztec-scanner-action.enum';
import {ApplicationContextService} from '../../../../../core/services/impl/configuration/application-context.service';

@Component({
  selector: 'app-next-aztec-scanner-notification',
  templateUrl: './next-aztec-scanner-notification.component.html',
  styleUrls: []
})
export class NextAztecScannerNotificationComponent implements OnInit {

  @Output() action: EventEmitter<AztecScannerAction> = new EventEmitter<AztecScannerAction>();

  contentVisible = false;
  title: string;
  subtitle: string;
  icon: string;
  buttonLabel: string;

  get translationsContainer(): string | null {
    if (this.aztecScannerService.aztecScannerResult) {
      return this.aztecScannerService.aztecScannerResult === AztecScannerResult.SUCCESS ? 'AZTEC_SCANNER.NOTIFICATION.SUCCESS' : 'AZTEC_SCANNER.NOTIFICATION.ERROR';
    }
    return null;
  }

  get scannerAction(): AztecScannerAction {
    return this.aztecScannerService.aztecScannerResult === AztecScannerResult.SUCCESS ? AztecScannerAction.CLOSE_APP : AztecScannerAction.CANCEL_SCANNING;
  }

  get subtitleVisible(): boolean {
    return !this.contextService.isDiagnosticStationContext;
  }

  constructor(private aztecScannerService: NextAztecScannerService,
              private contextService: ApplicationContextService) {}

  ngOnInit(): void {
    this.init();
  }

  onClick() {
    this.action.emit(this.scannerAction);
  }

  private init(): void {
    this.setTitle();
    this.setSubtitle();
    this.setIcon();
    this.setButtonLabel();
    this.contentVisible = true;
  }

  private setTitle() {
    if (this.aztecScannerService.aztecScannerResult === AztecScannerResult.SUCCESS) {
      this.title = `${this.translationsContainer}.TITLE`;
    } else {
      this.title = this.contextService.isDiagnosticStationContext ? `${this.translationsContainer}.DIAGNOSTIC_STATION_TITLE` : `${this.translationsContainer}.TITLE`;
    }
  }

  private setSubtitle(): void {
    this.subtitle = `${this.translationsContainer}.MESSAGE`;
  }

  private setIcon(): void {
    if (this.aztecScannerService.aztecScannerResult === AztecScannerResult.SUCCESS) {
      this.icon = './assets/images/icons/aztec-notification-success.svg';
    } else {
      this.icon = './assets/images/icons/aztec-notification-error.svg';
    }
  }

  private setButtonLabel(): void {
    this.buttonLabel = this.contextService.isDiagnosticStationContext ? `${this.translationsContainer}.DIAGNOSTIC_STATION_BUTTON_LABEL` : `${this.translationsContainer}.BUTTON_LABEL`;
  }

}
